<template>
  <div class="overall-bg p-0">
    <TabView class="tabview-custom tabviewtable" ref="tabview4" :scrollable="true">
      <TabPanel>
        <template #header>
          <span>{{ $t("invtabs.issue") }}</span>
        </template>
        <div>
          <div class="chip_class" v-if="filterItemsArray && filterItemsArray.length > 0">
            <div class="">
              <div class="filter_chip" v-if="filterItemsArray[0]['Date'] !== ''">
                <span>Date: {{ filterItemsArray[0]["Date"] }}</span>
                <span @click="removeChip('Date')"><i class="pi pi-times"></i>
                </span>
              </div>
              <div class="filter_chip" v-if="filterItemsArray[0]['issueCode'] !== ''">
                <span>Issue code: {{ filterItemsArray[0]["issueCode"] }}</span>
                <span @click="removeChip('issueCode')"><i class="pi pi-times"></i>
                </span>
              </div>
              <div class="filter_chip" v-if="filterItemsArray[0]['requestCode'] !== ''">
                <span>Request code: {{ filterItemsArray[0]["requestCode"] }}</span>
                <span @click="removeChip('requestCode')"><i class="pi pi-times"></i>
                </span>
              </div>
              <div class="filter_chip" v-if="filterItemsArray[0]['ToStore'] != ''">
                <span>To Store: {{ filterItemsArray[0]["ToStore"] }}</span>
                <span @click="removeChip('ToStore')"><i class="pi pi-times"></i>
                </span>
              </div>
              <!-- <div class="filter_chip" v-if="filterItemsArray[0]['recby'] != ''">
                <span>ReceivedBy: {{ filterItemsArray[0]["recby"] }}</span>
                <span @click="removeChip('recby')"><i class="pi pi-times"></i>
                </span>
              </div> -->
            </div>
            <div class="">
              <button class="btn resetallfilter me-2 rounded-pill float-end" @click="ResetFilter">
                Clear all
              </button>
            </div>
          </div>
          <div class="form-white-bg" v-if="windowWidth > 545">
            <b-row>
              <b-col :lg="visible ? '3' : '0'" v-if="items.length !== 0">
                <b-collapse id="collapse-1" class="mt-2" v-model="visible">
                  <FilterForm :sidedisplay="true" @FilterValues="Filter" @ResetValues="ResetFilter"
                    :ClearDateFilter="SearchValue" v-if="FilterLoading">
                    <template v-slot:filterslot>
                      <itemIssueFilter :issuesstatus="1" @tostorename="EmitToStore" @tostoreid="EmitToStoreId"
                        @updatedrequestcode="Emitrequestcode" @updatedissuecode="Emitissuecode"
                        :removechiptype="removechipvalue" @updatedreqby="Emitreqby" @reqname="EmitreqbyName"
                        @recname="EmitreqbyName" , @updatedrecby="EmitrecbyId" :dataList="items" />
                    </template>
                  </FilterForm>
                </b-collapse>
              </b-col>
              <b-col :lg="items.length !== 0 && visible ? '9' : '12'">
                <SkeletonTableLoader :columns="headers" :loading="loading" />
                <div v-if="!loading">
                  <MasterEmpty :createline="false" v-if="
                    items.length === 0 &&
                    !SearchValue.inputValue &&
                    !SearchValue.fromDate &&
                    !SearchValue.toDate
                  " eheader="Inbound Issue" econtent="Inbound Issue" eimg="/src/assets/Img/icons/itemmaster.svg"
                    @createNew="" />
                  <!-- {{ items }} -->
                  <Tableview :value="items" v-if="
                    items.length !== 0 ||
                    SearchValue.inputValue ||
                    SearchValue.fromDate ||
                    SearchValue.toDate
                  " class="p-datatable-gridlines" :rows="10" dataKey="id" :rowHover="true" filterDisplay="menu"
                    :loading="loading1" responsiveLayout="scroll" :columns="headers"
                    :globalFilterFields="globalFilterFields" :filters="filters" @row-click="RowClick"
                    :totalRecords="rowsCount" :state="state" @ShowRows="ShowRows" :searchbox="false" :searchbox1="true"
                    @search="SearchBox" :exceldownload="true" :filterbtn="true" :showColumnFilters="false">
                    <template v-slot:exceldownload>
                      <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                        :PageName="PageName" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                    </template>
                    <template v-slot:filter>
                      <i class="pi pi-filter tablefilter" :class="visible ? null : 'collapsed'"
                        :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-4"
                        @click="visible = !visible"></i>
                    </template>
                    <template v-slot:action="{ data }">
                      <span>
                        <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                          @click="toggle($event, data)" />
                      </span>
                    </template>
                    <template v-slot:RequestedByNameSlot="{ data }">
                      <span v-if="data.RequestedByName != null">
                        {{ data.RequestedByName }}
                      </span>
                      <span v-else>
                        {{ " - " }}
                      </span>
                    </template>
                    <template v-slot:RequestedDateSlot="{ data }">
                      <span v-if="data.RequestedDate != null">
                        {{ data.RequestedDate }}
                      </span>
                      <span v-else>
                        {{ " - " }}
                      </span>
                    </template>
                    <template v-slot:ApprovalStatus="{ data }">
                      <OrangeStatus name="Pending" v-if="data.IsApproved == '0' || data.IsApproved == '2'" />
                      <GreenStatus name="Approved" v-if="data.IsApproved == '1'" />
                      <RedStatus name="Declined" v-if="data.IsApproved == '3'" />
                    </template>
                  </Tableview>
                </div>
              </b-col>
            </b-row>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" v-for="item in 5" />
            <div v-if="!loading">
              <MasterEmpty :createline="false" v-if="
                items.length === 0 &&
                !SearchValue.inputValue &&
                !SearchValue.fromDate &&
                !SearchValue.toDate
              " eheader="Inbound Issue" econtent="Inbound Issue" eimg="/src/assets/Img/icons/itemmaster.svg"
                @createNew="" />
              <MobileViewCardHeader :totalRecords="rowsCount" :state="state" v-if="
                items.length !== 0 ||
                SearchValue.inputValue ||
                SearchValue.fromDate ||
                SearchValue.toDate
              " @search="SearchBox">
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in items" @click="RowClick(item)">
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <p class="light-name1">{{ item["DocNo"] }}</p>
                        <p class="light-name1">/{{ item["RefNo"] }}</p>
                      </div>
                      <i class="pi pi-ellipsis-v" @click.stop="toggle($event, item)"></i>
                    </div>
                    <p class="name">{{ item["ToStoreName"] }}</p>
                    <div class="d-flex align-items-center gap-2">
                      <p class="light-name">Item count :</p>
                      <p class="small-name">{{ item["ItemCount"] }}</p>
                    </div>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>
          <DeletedSuccessfully :visible="deletepop" @ok="deletepop = false" />
          <DeleteConfirmationVue :DeleteModel="Deletemodel" @yes="IsDelete(DataEdit)" @no="Deletemodel = false" />
          <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(DataEdit)" @no="Editmodel = false"
            :content="$t('confirmation.editcontent')" />
        </div>
      </TabPanel>
      <TabPanel>
        <template #header>
          <span>{{ $t("invtabs.returns") }}</span>
        </template>
        <div>
          <IssueReturnTableViewVue IssueType="OutBound" />
        </div>
      </TabPanel>
    </TabView>
  </div>

  <Menu ref="menus" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues" :PrintType="PrintType"
    @closepopup="hidepopup" />

  <Toast />
</template>
<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  reactive,
  onMounted,
  watch,
  onUnmounted,
} from "vue";

import Tableview from "../../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import commonService from "../../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import Service from "../../../../../../../modules/Inventory/Service/StockOutService";
import { useRoute, useRouter } from "vue-router";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import EditConfirmation from "../../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import ServiceIn from "../../../../../../../modules/Inventory/Service/StockInService";
import IssueReturnTableViewVue from "../../../../../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/IssueReturnTableView.vue";
import Loader from "../../../../../../../components/FormComponents/Loader.vue";
import MasterEmpty from "../../../../../../../components/Masters/MasterEmpty.vue";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../../../../modules/Inventory/Service/AccessControl";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import CrystalReportPrintPopUp from "../../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import moment from "moment";
import FilterForm from "../../../../../../../components/FormComponents/FilterForm.vue";
import itemIssueFilter from "../../../../../../../modules/Inventory/components/Filters/itemIssueFilters.vue";
import ExportOption from "../../../../../../../components/FormComponents/Export.vue";
import debounce from "lodash/debounce";

export default defineComponent({
  components: {
    Tableview,
    DeletedSuccessfully,
    EditConfirmation,
    DeleteConfirmationVue,
    IssueReturnTableViewVue,
    Loader,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    CrystalReportPrintPopUp,
    FilterForm,
    itemIssueFilter,
    ExportOption,
  },
  props: {
    showone: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    propsParams: {
      type: Object,
    },
    FunctionRights: {
      type: Object,
    },
  },

  setup(props, { emit }) {
    /* variable declaration*/
    let loading = ref(false);
    let showitemfield = ref(false);
    const router = useRouter();
    const datas = ref();
    const menus = ref();
    const Activevisible = ref(false);
    const generic = ref();
    let items = ref([]);
    let loading1 = ref(false);
    const toast = useToast();
    const route = useRoute();
    let visible = ref(false);

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let TransferFlag = localStorage.getItem("TransferFlag");
    let usersData: any;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    const CrystalReportPopup = ref(false);

    const ParameterValues = ref({
      Id: 0,
      BranchId: 0,
      HospitalId: 0,
    });

    const PrintType = ref({
      Type: "T",
      FormId: 10,
      HeaderTitle: "InBound Issue",
      ModuleId: 3,
    });

    let ExportList = ref([]);
    let PageName = ref("InBound Issue");
    let ExportOption = ref("");

    let StoreId = route.query.Id;
    let status = route.query.status ?? 0;
    let Types = route.query.Types;
    let StoreBranchMapId = route.query.storebranchmapid;

    const paramValue = computed(() => {
      return route.query.param as string;
    });

    const deletepop = ref(false);
    const Deletemodel = ref(false);
    const Editmodel = ref(false);
    const { t } = useI18n();
    const rowFocus = ref(false);
    let DataEdit = ref();
    let StockOutTransId = 0;
    let DocType;

    function onRowClick(event: Event, rowData: any) {
      emit("row-click", rowData);
    }

    const rowsCount = ref(0);
    const state = reactive({
      pagedItems: [], // contains a subset of rows for the current page
      currentPage: 1, // current page number
      pageSize: 10, // number of rows per page
      totalRows: 0, // total number of rows in the database
    });

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    let QueryStringValue3: any = route.query;

    onMounted(() => {
      localStorage.getItem("UsersData");
      window.addEventListener("resize", handleResize);
      if (windowWidth.value < 545) {
        state.pageSize = 5;
      } else {
        state.pageSize = 10;
      }
      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    watch(
      () => windowWidth.value,
      (newVal) => {
        if (newVal < 545) {
          state.pageSize = 5;
        } else {
          state.pageSize = 10;
        }
      }
    );

    function toggle(event, data) {
      debugger;
      console.log(event);
      if (data.ReturnStatus == 0) {
        Activevisible.value = true;
      } else {
        Activevisible.value = false;
      }

      datas.value = data;
      menus.value.toggle(event);
    }

    const itemListed = ref([
      {
        items: [
          {
            label: "Issue Return",
            icon: "editicon pi pi-check-circle",
            visible: true,
            command: async () => {
              // IssueReturn(datas.value);
              RowClick(datas.value);
            },
          },
          {
            label: "Print",
            icon: "editicon pi pi-print",
            command: async () => {
              Print(datas.value);
            },
          },
        ],
      },
    ]);

    let Rights: any = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    watch(props, (newValue: any) => {
      debugger;
      console.log("props Changed", newValue.FunctionRights);
      Rights.value.Create = newValue.FunctionRights.Create;
      Rights.value.Update = newValue.FunctionRights.Update;
      Rights.value.Read = newValue.FunctionRights.Read;
      Rights.value.Delete = newValue.FunctionRights.Delete;
    });

    const headers = [
      {
        header: t("storetabdetails.inboundissue.sno"),
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: t("storetabdetails.inboundissue.Code"),
        field: "DocNo",
        bodyclass: "boldclass text_overflow2",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.inboundissue.FromStore"),
        field: "FromStoreName",
        // bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: t("storetabdetails.inboundissue.ToStore"),
        field: "ToStoreName",
        // bodyclass: "boldclass text_overflow2",
        class: "mediumwidth",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: t("storetabdetails.inboundissue.ReqBy"),
        field: "RequestedByName",
        // bodyclass: "boldclass",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        slot: "RequestedByNameSlot",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.inboundissue.ReqDate"),
        field: "RequestedDate",
        // bodyclass: "boldclass",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
        slot: "RequestedDateSlot",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.inboundissue.RecDate"),
        field: "ReceivedDate",
        // bodyclass: "boldclass",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.inboundissue.RecBy"),
        field: "ReceivedByName",
        // bodyclass: "boldclass",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.inboundissue.ItemCount"),
        field: "ItemCount",
        bodyclass: "bluecolor right_td",
        class: "smallwidth",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: t("storetabdetails.inboundissue.RequestId/IssueId"),
        field: "RequestRefNo",
        bodyclass: "boldclass text_overflow2",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "smallwidth",
      },
      // {
      //   header: t('storetabdetails.inboundissue.Status'),
      //   field: "",
      //   fieldDisplay: "false",
      //   slot: "ApprovalStatus",
      //   sortable: false,
      //   filterTemplate: "MultiSelect",
      //   ShowMactchMode: false,
      //   class: "",
      // },
      {
        header: t("storetabdetails.inboundissue.ApprovalStatus"),
        field: "",
        fieldDisplay: "false",
        slot: "ApprovalStatus",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "",
      },
      {
        field: "action",
        header: "",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        class: "filterdisplaynone last-column-position",
        fieldDisplay: "false",
      },
    ];

    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DocNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      RefNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      ToStoreName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };

    // row click for table
    function RowClick(event: any) {
      debugger;

      rowFocus.value = true;
      DataEdit.value = event.data
        ? event.data.StockTransId
        : event.StockTransId;
      router.push({
        path: "/InboundIssueDetails",
        query: {
          Id: event.data ? event.data.StockTransId : event.StockTransId,
          BranchId: QueryStringValue3["BranchId"],
        },
      });
    }

    function Editdata(data) {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Edit");

      if (permissionResult.hasPermission) {
        DataEdit.value = data;
        StockOutTransId = data.StockOutTransId;
        DocType = data.DocType;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    function Deletedata(data) {
      debugger;
      let permissionResult: any = checkPermission(Rights, "Delete");

      if (permissionResult.hasPermission) {
        DataEdit.value = data;
        StockOutTransId = data.StockOutTransId;
        DocType = data.DocType;
        Deletemodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }

    const globalFilterFields = ref(headers.map((col) => col.field));

    let ParamValues = ref({
      requestId: "",
      StockOutTransTMId: 0,
      fromStoreId: 0,
      toStoreId: 0,
      type: 2,
      StockTransId: 0,
      status: status,
      Types: Types,
    });

    let dataValue = {
      Id: "",
      status: "",
      Type: "",
    };

    watch(props, (newValue) => {
      debugger;
      Object.assign(dataValue, newValue.propsParams);
      if (dataValue.Id) {
        items.value = [];
        StoreId = dataValue.Id;
        status = Number(dataValue.status);
        Types = String(dataValue.Type);
        IsShow();
      }
    });

    ParamValues.value.fromStoreId = QueryStringValue3["Id"];

    const IsCreate = () => {
      debugger;
      router.push({
        path: "/Issue",

        query: {
          data: JSON.stringify(ParamValues.value),
          param: "DirectIssue",
        },
      });
    };

    function IsEdit(DataEdit) {
      debugger;

      console.log(DataEdit["DocNo"]);
      ParamValues.value.requestId = DataEdit["DocNo"];
      ParamValues.value.StockOutTransTMId = DataEdit["StockOutTransId"];
      ParamValues.value.fromStoreId = DataEdit["FromStoreId"];
      ParamValues.value.toStoreId = DataEdit["ToStoreId"];

      router.push({
        path: "/Issue",

        query: {
          data: JSON.stringify(ParamValues.value),
          param: "DirectIssue",
        },
      });
    }

    function ShowRows(value) {
      debugger;
      if (value != 0 && value != null && value != undefined) {
        state.pageSize = value;
        IsShow();
      }
    }

    watch(
      [() => state.currentPage, () => state.pageSize],
      async ([pageNum, pageSize]) => {
        debugger;
        await IsShow();
      }
    );

    // Debounced search for server-side filtering
    function SearchBox(value) {
      if (value === "" || value.length >= 3) {
        debouncedSearch(value);
      }
    }

    const debouncedSearch = debounce((input) => {
      SearchValue.value.inputValue = input;
      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      IsShow();
    }, 300);

    //Get data for TableView
    async function IsShow() {
      debugger;
      try {
        loading.value =
          SearchValue.value.inputValue ||
            SearchValue.value.fromDate ||
            SearchValue.value.toDate
            ? false
            : true;

        const pageNum = state.currentPage;
        const pageSize = state.pageSize;
        const columnName = "StoreId";
        const columnValue = StoreId;
        const columnName1 = filterItems.value.tostoreId ? "FromStore" : "";
        const columnValue1 = filterItems.value.tostoreId
          ? filterItems.value.tostoreId
          : "";
        const columnName2 = filterItems.value.requestCode ? "RefNo" : "";
        const columnValue2 = filterItems.value.requestCode
          ? filterItems.value.requestCode
          : "";
        const columnName3 = filterItems.value.issueCode ? "DocNo" : "";
        const columnValue3 = filterItems.value.issueCode
          ? filterItems.value.issueCode
          : "";
        const columnName4 = filterItems.value.reqby ? "Createdby" : "";
        const columnValue4 = filterItems.value.reqby
          ? filterItems.value.reqby
          : "";

        const columnName5 = filterItems.value.recby ? "Createdby" : "";
        const columnValue5 = filterItems.value.recby
          ? filterItems.value.recby
          : "";
        const columnName6 = TransferFlag === "1" ? "IsApproved" : "";
        const columnValue6 = TransferFlag === "1" ? 0 : "";

        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }
        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          "  and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.ToStoreBranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))";
        let response = await ServiceIn.List(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          "10,11,22",
          pageNum,
          pageSize,
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          Flag,
          searchOption,
          columnName3,
          columnValue3,
          columnName4,
          columnValue4,
          columnName5,
          columnValue5,
          columnName6,
          columnValue6,
          Condition
        );

        let count = 0;
        items.value = response["result"].map((item) => {
          count = count + 1;
          item.RowNumber = count;

          return item;
        });
        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;
        console.log(items.value);
        loading.value = false;
        localStorage.removeItem("TransferFlag");
      } catch (error) {
        console.log(error);
      }
    }

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const pageNum = state.currentPage;
        const pageSize = 0;
        const columnName = "StoreId";
        const columnValue = StoreId;
        const columnName1 = filterItems.value.tostoreId ? "FromStore" : "";
        const columnValue1 = filterItems.value.tostoreId
          ? filterItems.value.tostoreId
          : "";
        const columnName2 = filterItems.value.requestCode ? "RefNo" : "";
        const columnValue2 = filterItems.value.requestCode
          ? filterItems.value.requestCode
          : "";
        const columnName3 = filterItems.value.issueCode ? "DocNo" : "";
        const columnValue3 = filterItems.value.issueCode
          ? filterItems.value.issueCode
          : "";

        const columnName4 = filterItems.value.reqby ? "Createdby" : "";
        const columnValue4 = filterItems.value.reqby
          ? filterItems.value.reqby
          : "";

        const columnName5 = filterItems.value.recby ? "Createdby" : "";
        const columnValue5 = filterItems.value.recby
          ? filterItems.value.recby
          : "";
        const columnName6 = TransferFlag === "1" ? "IsApproved" : "";
        const columnValue6 = TransferFlag === "1" ? 0 : "";

        let Flag = 1,
          searchOption = "";

        if (SearchValue.value.inputValue != "") {
          Flag = 2;
          searchOption = SearchValue.value.inputValue;
        }
        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          "  and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.ToStoreBranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))";

        let response = await ServiceIn.List(
          SearchValue.value.fromDate ? SearchValue.value.fromDate : "",
          SearchValue.value.toDate ? SearchValue.value.toDate : "",
          "10,11,22",
          pageNum,
          pageSize,

          columnName,
          columnValue,
          columnName1,
          columnValue1,
          columnName2,
          columnValue2,
          Flag,
          searchOption,
          columnName3,
          columnValue3,
          columnName4,
          columnValue4,
          columnName5,
          columnValue5,
          columnName6,
          columnValue6,
          Condition
        );

        rowsCount.value =
          response["result"].length > 0
            ? response["result"][0]["rowscount"]
            : 0;

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log(items.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    //Delete Values in Table
    async function IsDelete(DataEdit) {
      debugger;
      console.log(StockOutTransId);
      try {
        const response = await Service.DeleteStockOutTM(StockOutTransId);
        console.log(response["result"]);
        let msg = response["ErrorInfo"].ErrorCode;
        if (msg == null) {
          deletepop.value = true;
          Deletemodel.value = false;
          IsShow();
        }
      } catch (error) {
        console.log(error);
      }
    }

    const ParamVal = ref({
      issueId: "",
      StockOutTransTMId: 0,
      fromStoreId: StoreId,
      toStoreId: 0,
      type: 3,
      StockTransId: 0,
      status: status,
      Types: Types,
      EntityId: 0,
      OperationId: 0,
    });

    async function IssueReturn(data) {
      debugger;
      console.log(data["DocNo"]);
      ParamVal.value.issueId = data["DocNo"];
      ParamVal.value.StockTransId = data["StockTransId"];
      ParamVal.value.EntityId = 3030;
      ParamVal.value.OperationId = 3030001;

      router.push({
        path: "/Issue",

        query: {
          data: JSON.stringify(ParamVal.value),
          param: "IssueReturn",
        },
      });
    }

    function Print(ObjData) {
      debugger;
      CrystalReportPopup.value = true;

      ParameterValues.value.Id = ObjData.RefId;
      ParameterValues.value.BranchId = ObjData.ToStoreBranchId;
      ParameterValues.value.HospitalId = ObjData.HospitalId;
    }

    const hidepopup = () => {
      CrystalReportPopup.value = false;
    };

    let FilterLoading = ref(true);
    const filtervisible = ref(false);
    let filterItemsArray: any = ref([]);
    let filterItems = ref({
      Date: "",
      ToStore: "",
      tostoreId: "",
      requestCode: "",
      issueCode: "",
      recby: "",
      reqby: "",
    });

    let emitedfilterItems = ref({
      ToStore: "",
      tostoreId: "",
      requestCode: "",
      issueCode: "",
      recby: "",
      recbyName: "",

      reqby: "",
      reqbyName: "",
    });
    let SearchValue = ref({
      inputValue: "",
      fromDate: "",
      toDate: "",
    });
    const removechipvalue = ref(0);

    const EmitToStore = (data) => {
      emitedfilterItems.value.ToStore = data;
    };

    const EmitToStoreId = (data) => {
      emitedfilterItems.value.tostoreId = data;
    };

    const Emitrequestcode = (data) => {
      emitedfilterItems.value.requestCode = data;
    };

    const Emitissuecode = (data) => {
      emitedfilterItems.value.issueCode = data;
    };

    function Filter(values) {
      debugger;
      if (
        values.fromdate !== undefined &&
        values.fromdate !== "" &&
        values.todate !== undefined &&
        values.todate !== ""
      ) {
        filterItems.value.Date =
          moment(values.fromdate).format("DD MMM YY") +
          " To " +
          moment(values.todate).format("DD MMM YY");
      } else if (values.fromdate !== undefined && values.fromdate !== "") {
        filterItems.value.Date = moment(values.fromdate).format("DD MMM YY");
      } else if (values.todate !== undefined && values.todate !== "") {
        filterItems.value.Date = moment(values.todate).format("DD MMM YY");
      } else {
        filterItems.value.Date = "";
      }

      // filterItems.value.LineOfBusiness = ServiceTypeNames;
      // filterItems.value.Type = TaskTypeNames;
      filterItems.value.ToStore = emitedfilterItems.value.ToStore;
      filterItems.value.tostoreId = emitedfilterItems.value.tostoreId;
      filterItems.value.requestCode = emitedfilterItems.value.requestCode;
      filterItems.value.issueCode = emitedfilterItems.value.issueCode;

      filterItems.value.reqby = emitedfilterItems.value.reqby;
      filterItems.value.recby = emitedfilterItems.value.recby;

      filterItemsArray.value = [];

      filterItemsArray.value.push(filterItems.value);

      SearchDate(values.fromdate, values.todate);
      removechipvalue.value = 0;
      filtervisible.value = false;
    }

    function ResetFilter(values) {
      debugger;
      SearchValue.value.fromDate = "";
      SearchValue.value.toDate = "";
      removechipvalue.value = 4;
      filterItems.value.tostoreId = "";
      filterItems.value.requestCode = "";
      filterItems.value.issueCode = "";

      filterItems.value.recby = "";
      filterItems.value.reqby = "";
      // filterItems.value.i = "";

      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;
      filterItemsArray.value = [];
      filterItems.value.Date = "";
      IsShow();
    }
    function SearchDate(fromDate, ToDate) {
      debugger;
      SearchValue.value.fromDate = fromDate
        ? moment(fromDate).format("YYYY-MM-DD")
        : "";
      SearchValue.value.toDate = ToDate
        ? moment(ToDate).format("YYYY-MM-DD")
        : "";

      state.pagedItems = [];
      state.currentPage = 1;
      state.pageSize = 10;
      state.totalRows = 0;

      IsShow();
    }

    const removeChip = (data) => {
      debugger;
      if (data == "Date") {
        SearchValue.value.fromDate = "";
        SearchValue.value.toDate = "";
      } else if (data == "issueCode") {
        removechipvalue.value = 1;
      } else if (data == "requestCode") {
        removechipvalue.value = 2;
      } else if (data == "ToStore") {
        filterItems.value.tostoreId = "";
        removechipvalue.value = 3;
      }
      filterItems.value[data] = ""; // Clear the value in the filterItems object
      IsShow();
    };
    const Emitreqby = (data) => {
      // alert(data)
      emitedfilterItems.value.reqby = data;
    };
    const EmitreqbyName = (data) => {
      emitedfilterItems.value.reqbyName = data;
    };
    const EmitrecbyId = (data) => {
      emitedfilterItems.value.recby = data;
    };

    return {
      EmitreqbyName,

      Emitreqby,
      EmitrecbyId,
      showitemfield,
      items,
      headers,
      loading,
      paramValue,
      onRowClick,
      IsShow,
      IsEdit,
      IsDelete,
      IsCreate,
      loading1,
      globalFilterFields,
      filters,
      Editdata,
      Deletedata,
      Deletemodel,
      deletepop,
      Editmodel,
      RowClick,
      DataEdit,
      IssueReturn,
      rowsCount,
      state,
      itemListed,
      menus,
      toggle,
      CrystalReportPopup,
      ParameterValues,
      PrintType,
      hidepopup,
      Filter,
      ResetFilter,
      filterItemsArray,
      filtervisible,
      SearchValue,
      FilterLoading,
      EmitToStore,
      EmitToStoreId,
      Emitrequestcode,
      Emitissuecode,
      removeChip,
      removechipvalue,
      SearchBox,
      ExportOption,
      ExportList,
      PageName,
      ExportExcel,
      ExportPDF,
      ShowRows,
      windowWidth,
      visible,
    };
  },
});
</script>
